module.exports = __webpack_public_path__ + "img/warning.0d4e9d20.svg";